'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function getMonths($calendarData) {
        var $calendarDataItem = $calendarData.find('[data-binding="calendar-data-item"]'),
            monthsSeen = [];

        $calendarDataItem.each(function () {
            monthsSeen.push(parseInt($(this).text()));
        });

        return monthsSeen;
    }

    function selectMonths(months) {
        months.forEach(function (month) {
            var prevMont = month - 1;
            $('[data-binding="calendar-months"]').find('[data-month="' + month + '"]').addClass('active');

            // find prev month - see if it's in array and add class if it is
            if (months.indexOf(prevMont) > -1) {
                $('[data-binding="calendar-months"]').find('[data-month="' + month + '"]').addClass('hasprev');
            }
        });
    }

    function init() {
        var $calendarData = context.find('[data-binding="calendar-data"]'),
            $calendarSeasons = context.find('[data-binding="calendar-seasons"]'),
            calendarMonthElement = '<ul class="species-calendar__months" data-binding="calendar-months"><li class="species-calendar__months__month" data-binding="calendar-month" data-month="1">Jan</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="2">Feb</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="3">Mar</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="4">Apr</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="5">May</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="6">Jun</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="7">Jul</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="8">Aug</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="9">Sep</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="10">Oct</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="11">Nov</li><li class="species-calendar__months__month" data-binding="calendar-month" data-month="12">Dec</li></ul>',
            months = getMonths($calendarData);

        $calendarSeasons.after(calendarMonthElement);

        selectMonths(months);
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/species-calendar.js
// module id = 264
// module chunks = 0